// Ordenação de fotos por sequência de exibição (FEAT-016).
//
// Lâminas do fotolivro: a CAPA é sempre a posição 1; as demais seguem
// `display_order` (novas/legado sem ordem vão para o fim, por data de upload).
// Demais tipos de foto: data de upload (created_at).

// Comparator para listas SÓ de lâminas (galeria de lâminas).
export const spreadSequenceComparator = (a, b) => {
  if (!!a.is_cover_photo !== !!b.is_cover_photo) {
    return a.is_cover_photo ? -1 : 1;
  }

  const orderA = a.display_order ?? Infinity;
  const orderB = b.display_order ?? Infinity;

  if (orderA !== orderB) return orderA - orderB;

  return new Date(a.created_at) - new Date(b.created_at);
};

// Comparator geral (listas mistas ou de tipo único): aplica a sequência de
// lâminas quando ambos são 'Lâmina'; caso contrário, data de upload.
export const photoSequenceComparator = (a, b) => {
  if (a.photo_type === 'Lâmina' && b.photo_type === 'Lâmina') {
    return spreadSequenceComparator(a, b);
  }

  return new Date(a.created_at) - new Date(b.created_at);
};
